import { setMemberToken } from "../containers/Login/slice";
import { store } from "../../utils/redux/store";

/**
 * Handle memberToken from URL before app initialization
 * This runs synchronously before React renders
 */
export const handleMemberTokenBeforeInit = () => {
  // Get current URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const memberToken = urlParams.get("memberToken");

  if (!memberToken) {
    return;
  }

  // Check if we should process this route
  const pathname = window.location.pathname;

  // Skip public routes
  const publicPaths = [
    "/login",
    "/create-account",
    "/verify-email",
    "/reset-password",
    "/app-download",
    "/register-success",
  ];

  if (publicPaths.includes(pathname)) {
    return;
  }

  // Skip standalone routes
  if (pathname.startsWith("/compiled-reports/")) {
    return;
  }

  console.log("MemberToken: Found token in URL, processing before app init");

  // Store token immediately
  localStorage.setItem("token", memberToken);

  // Set validation flag so AppContent knows to validate this token
  localStorage.setItem("memberTokenNeedsValidation", "true");

  // Update Redux state immediately
  store.dispatch(setMemberToken(memberToken));

  // Clean up URL without navigation (just replace history)
  urlParams.delete("memberToken");
  const cleanUrl = `${pathname}${urlParams.toString() ? "?" + urlParams.toString() : ""}`;
  window.history.replaceState(null, "", cleanUrl);

  console.log("MemberToken: Token processed, URL cleaned");
};
